<template>
  <div class="item-wrapper">
    <h2 class="item-name">{{ data.name }}</h2>
    <div class="item-content">
      <div class="item-delta">
        <div :class="percentageClass">{{ data.delta | formatDelta }}</div>
      </div>
      <div class="item-value">
        <div class="item-value__this">
          <div class="item-value__label">Current period: {{ data.month }}</div>
          <div class="item-value__number">
            {{ data.value | formatNumber }}
            <span class="item-value__hits">hits</span>
          </div>
        </div>
        <div class="item-value__last">
          <div class="item-value__label">
            Previous period: {{ data.lastMonth }}
          </div>
          <div class="item-value__number">
            {{ data.lastValue | formatNumber }}
            <span class="item-value__hits">hits</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatNumber from '../../../filters/formatNumber.js';
export default {
  props: ['data'],
  computed: {
    percentageClass() {
      if (!this.data) {
        return '';
      }
      return this.data.delta === 0
        ? ''
        : this.data.delta === 'Infinity'
        ? 'item-infinity icon-icon_increase'
        : this.data.delta > 0
        ? 'item-delta--inc icon-icon_increase'
        : 'item-delta--dec icon-icon_decrease';
    }
  },
  filters: {
    formatNumber,
    formatDelta(value) {
      if (value === 0) {
        return '- %';
      }
      if (value < 0) {
        return value.replace('-', '');
      }
      if (value === 'Infinity') {
        return 'Increasing';
      }
      return value;
    }
  }
};
</script>

<style scoped lang="scss">
.item-wrapper {
  flex: 1;
  padding: 0.75rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.item-label {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 4px 7px 0;

  .item-name {
    width: 75%;
  }

  span {
    font-size: 0.9rem !important;
    margin-right: 3px;
  }
}

.item-name {
  line-height: 1.1;
  margin-bottom: 4px;

  @media screen and (max-width: 485px) {
    font-size: 20px;
  }
}

.item-content {
  display: flex;
  flex-direction: column;

  .item-value {
    font-weight: 500;
    flex: 1;
    font-size: 16px;

    &__label {
      font-weight: 500;
    }

    &__number {
      font-size: 28px;
    }

    &__hits {
      font-size: 16px;
    }

    &__this {
      margin-bottom: 10px;
    }

    &__this,
    &__last {
      & > :last-child {
        font-size: 28px;

        @media screen and (max-width: 485px) {
          font-size: 20px;
        }
      }
    }
  }

  .item-delta {
    flex: 0.5;
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 28px;
    margin-bottom: 20px;

    [class^='item-delta--'] {
      &::before {
        position: absolute;
        left: 0;
        top: 6px;

        @media screen and (max-width: 485px) {
          font-size: 80%;
          top: 7px;
        }
      }
      &::after {
        content: '%';
        position: absolute;
        font-size: 28px;
        margin-left: 2px;
        @media screen and (max-width: 526px) {
          font-size: inherit;
        }
      }
    }

    & > :last-child {
      font-size: 28px;
      font-weight: bold;
      padding-left: 28px;
      padding-right: 10px;

      @media screen and (max-width: 485px) {
        font-size: 20px;
        padding-left: 20px;
      }
    }

    &--inc,
    &--dec {
      position: relative;
    }

    &--inc {
      color: #b00020;
    }

    &--dec {
      color: #208836;
    }
  }

  .item-infinity {
    position: relative;
    color: #b00020;

    &::before {
      position: absolute;
      left: 0px;
      top: 6px;

      @media screen and (max-width: 485px) {
        font-size: 80%;
        top: 7px;
      }
    }
  }

  @media screen and (max-width: 425px) {
    flex-direction: column;
  }
}
</style>
